import { render, staticRenderFns } from "./QaSession.vue?vue&type=template&id=6d48eb20&scoped=true&"
import script from "./QaSession.vue?vue&type=script&lang=js&"
export * from "./QaSession.vue?vue&type=script&lang=js&"
import style0 from "./QaSession.vue?vue&type=style&index=0&id=6d48eb20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d48eb20",
  null
  
)

export default component.exports